// extracted by mini-css-extract-plugin
export var barContainer = "_2a-0";
export var extraThin = "_2a-3";
export var fillBar = "_2a-6";
export var fillContainer = "_2a-4";
export var overflow = "_2a-8";
export var overflowContainer = "_2a-5";
export var regular = "_2a-7";
export var thick = "_2a-1";
export var thin = "_2a-2";